export default __webpack_public_path__ + "static/univers-cond-19a40dc19f1c3c15591e78a30d69505e.woff2";